import {
    MoneyPage,
    AddPage,
    PlacePage,
    NotFoundPage,
    StatsPage,
    LoginPage,
    TripPage,
    LogoutPage,
    ExercisePage,
    BooksPage,
    BookPage,
    SummaryPage,
    TestPage,
} from '~/pages';

const publicRoutes = [
    { path: '/test', component: TestPage },
    { path: '/summary', component: SummaryPage },
    { path: '/book', component: BookPage },
    { path: '/lesson', component: ExercisePage },
    { path: '/login', component: LoginPage },
    { path: '/', component: BookPage },
    { path: '*', component: NotFoundPage },
];

const privateRoutes = [
    { path: '/logout', component: LogoutPage },
    { path: '/trip', component: TripPage },
    { path: '/money', component: MoneyPage },
    { path: '/place', component: PlacePage },
    { path: '/add/:cloneId?', component: AddPage },
    { path: '/add/:cloneId', component: AddPage },
    { path: '/edit/:editId', component: AddPage },
    { path: '/moneys/:id?', component: MoneyPage },
    { path: '/stats', component: StatsPage },
];

export { publicRoutes, privateRoutes };
